export enum Entities {
  classrooms = 'classrooms',
  users = 'users',
  programs = 'programs',
  schools = 'schools',
}
